<template>
  <div class="wrap" v-loading="allLoading">
    <div class="main-wrap my-orders">
      <!-- 顶部区（导航+标题），ref 供表格高度计算 -->
      <div class="top-area" ref="topBox">
        <div class="order-navigation">
          <router-link
            class="text1"
            to="/catalogue"
          >{{L.home}}</router-link>
          <span class="line">/</span>
          <router-link
            class="text2"
            to="/opportunity"
          >My Opportunities</router-link>
        </div>
        <div class="my-orders-title">
          <span class="title-text">My Opportunities</span>
          <div class="btn-with-bg" @click="goProductListView">
            <span class="iconfont icon-switch">&#xe68a;</span>
            <span>Switch to Product List View</span>
          </div>
        </div>
      </div>
      <!-- 表格上方通栏：左总数+过滤文字，右图标按钮组（照 cqm2 Technical .btn-box，去掉 Column Settings） -->
      <div class="btn-box" ref="btnBox">
        <div class="left-text">{{paginationObj.total}} items • {{filterText}}</div>
        <div class="btn-wrap">
          <div class="btn-no-bg" @click="goOpportunityDetail('New')">New</div>
          <div class="continuous-btn-no-bg">
            <div class="btn btn-icon" @click="handleRefresh">
              <span class="iconfont icon-refresh">&#xe611;</span>
            </div>
            <div class="btn btn-icon"  @click="handleDownload">
              <span class="iconfont icon-download">&#xe61c;</span>
            </div>
            <div class="btn btn-icon" :class="{'active':showFilter}" @click="handleFilter">
              <span class="iconfont icon-filter">&#xe8d7;</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 表格 + 右侧可隐藏过滤浮层（照 cqm2 Technical：.table-wrap flex，.filter-wrap 与表格做兄弟、v-show 显隐） -->
      <div class="table-wrap">
        <el-table
          ref="table"
          class="cqm-table"
          :height="tableHeight"
          highlight-current-row
          size="mini"
          :data="list"
          @row-dblclick="handleRowDblClick"
        >
          <el-table-column
            align="center"
            type="index"
            label=""
            width="50">
          </el-table-column>
          <el-table-column
            width="130"
            prop="oppNo"
            label="Opportunity No.">
              <template slot-scope="scope">
                <!-- 单击商机编号进入详情(编辑态)；整行双击同样进入，见 el-table @row-dblclick -->
                <span class="opp-no" @click="goOpportunityDetail(scope.row.oppNo)">{{scope.row.oppNo}}</span>
              </template>
          </el-table-column>
          <el-table-column
            width="100"
            prop="createTime"
            label="Created Date">
            <template slot-scope="scope">
              <span>{{ formatDateNoTime(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            prop="status"
            label="Status">
            <template slot-scope="scope">
              <span :class="getOppStatusColor(scope.row.status)">{{ getOppStatusText(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            prop="oppName"
            label="Opportunity Name">
          </el-table-column>
          <el-table-column
            width="100"
            prop="projectType"
            label="Project Type">
            <template slot-scope="scope">
              <span>{{ getOppProjectTypeText(scope.row.projectType) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            prop="buyingCustomerName"
            label="Ordering Customer">
          </el-table-column>
          <el-table-column
            width="200"
            prop="endCustomerName"
            label="End Customer">
          </el-table-column>
          <el-table-column
            width="260"
            prop="salesEmail"
            label="Salesperson Email">
          </el-table-column>
          <el-table-column
            width="150"
            prop="appType"
            label="Application Type">
            <template slot-scope="scope">
              <span>{{ getOppApplicationTypeText(scope.row.appType) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="130"
            prop="winRate"
            label="Win Probability">
            <template slot-scope="scope">
              <span>{{ getOppWinProbabilityText(scope.row.winRate) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            prop="stage"
            label="Stage">
            <template slot-scope="scope">
              <span>{{ getOppStageText(scope.row.stage) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            prop="annualRevenue"
            label="Est. Annual Rev. (Excl. Tax)">
            <template slot-scope="scope">
              <span>￥{{ scope.row.annualRevenue }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="240"
            prop="projectRevenue"
            label="Est. Proj Period Rev (Excl. Tax)">
            <template slot-scope="scope">
              <span>￥{{ scope.row.projectRevenue }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="130"
            prop="earliestDeliveryStart"
            label="Est. Delivery Start">
            <template slot-scope="scope">
              <span>{{ formatDateNoTime(scope.row.earliestDeliveryStart) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="130"
            prop="latestDeliveryEnd"
            label="Est. Delivery End">
            <template slot-scope="scope">
              <span>{{ formatDateNoTime(scope.row.latestDeliveryEnd) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 右侧可隐藏过滤浮层（照 cqm2 Technical .filter-wrap：title-close + content-scroll + save-btn；v-show 控制显隐）
             高度显式绑定 tableHeight：整体与表格齐高，内部 content-scroll(flex:1+overflow-y:auto) 才能在字段过多时单独滚动 -->
        <div class="filter-wrap" v-show="showFilter" :style="{height: tableHeight + 'px'}">
          <div class="title-close">
            <div class="left-text">Filters</div>
            <span class="iconfont icon-close" @click="closeFilter">&#xe65e;</span>
          </div>
          <div class="content-scroll" ref="filterWrap">
            <div class="search-wrap">
              <div class="search-text">Created Date From</div>
              <div class="date-wrap">
                <el-date-picker size="mini" class="search-inp search-inp-date" v-model="search.createTimeFrom" type="date" value-format="yyyy-MM-dd" format="dd-MM-yyyy" :picker-options="pickerOptions"></el-date-picker>
              </div>
            </div>
            <div class="search-wrap">
              <div class="search-text">Created Date To</div>
              <div class="date-wrap">
                <el-date-picker size="mini" class="search-inp search-inp-date" v-model="search.createTimeTo" type="date" value-format="yyyy-MM-dd" format="dd-MM-yyyy" :picker-options="pickerOptions"></el-date-picker>
              </div>
            </div>
            <div class="search-wrap">
              <div class="search-text">End Customer</div>
              <el-input class="search-inp" @keyup.enter.native="getList(2)" size="mini" v-model="search.endCustomerName"></el-input>
            </div>
            <div class="search-wrap">
              <div class="search-text">Status</div>
              <el-select size="mini" v-model="search.status" class="inp" placeholder="Please select" multiple clearable>
                <el-option
                  v-for="item in enumerate.oppStatus"
                  :key="item.code"
                  :label="item.nameEn"
                  :value="item.code">
                </el-option>
              </el-select>
            </div>
            <div class="search-wrap">
              <div class="search-text">Project Type</div>
              <el-select size="mini" v-model="search.projectType" class="inp" placeholder="Please select" multiple clearable>
                <el-option
                  v-for="item in enumerate.oppProjectType"
                  :key="item.code"
                  :label="item.nameEn"
                  :value="item.code">
                </el-option>
              </el-select>
            </div> 
            <div class="search-wrap">
              <div class="search-text">Application Type</div>
              <el-select size="mini" v-model="search.appType" class="inp" placeholder="Please select" multiple clearable>
                <el-option
                  v-for="item in enumerate.oppApplicationType"
                  :key="item.code"
                  :label="item.nameEn"
                  :value="item.code">
                </el-option>
              </el-select>
            </div>
            <div class="search-wrap">
              <div class="search-text">Stage</div>
              <el-select size="mini" v-model="search.stage" class="inp" placeholder="Please select" multiple clearable>
                <el-option
                  v-for="item in enumerate.oppStage"
                  :key="item.code"
                  :label="item.nameEn"
                  :value="item.code">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="save-btn">
            <span class="search reset" @click="clearFilters">{{L.cleaFilters}}</span>
            <span class="search" @click="getList(2)">{{L.search}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页：控件一模一样照抄 cqm2 Technical/index.vue —— 裸 el-pagination（prev/pager/next + pager-count 5）；
         外层内套 .main-wrap，使分页条最大宽度与上方表格一致并居中对齐（不再贴视口左下角） -->
    <div class="page-wrap" ref="pageBox">
      <div class="main-wrap page-inner">
        <el-pagination
          :pager-count="5"
          @current-change="currentChange"
          :current-page="paginationObj.currentPage"
          :page-size="paginationObj.pageSize"
          layout="prev, pager, next"
          :total="paginationObj.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {postAction,downFilePost} from '@/api/tool'
import {api_opportunity_list,api_download_opp_list} from '@/api/api'
import moment from 'moment'
import selectMixin from '@/mixins/selectMixins'

export default {
  name:'Opportunity',
  mixins:[selectMixin],
  data(){
    return {
      tableHeight:200, //表格固定高度，由 handleResize 动态计算（参考 cqm2 Technical）
      showFilter:false, //右侧过滤浮层是否显示（默认隐藏，点顶部过滤图标打开）
      search:{
        createTimeFrom:'',
        createTimeTo:'',
        projectType:[], //多选，后端要数组
        endCustomerName:'',
        appType:[], //多选，后端要数组
        stage:[], //多选，后端要数组
        status:[] //多选，后端要数组
      },
      list:[], //列表数据
      //表格滚动位置快照：本页被 keep-alive 缓存，离开时 DOM 被摘除会丢失滚动位置，故实时记录、返回时还原
      savedScrollTop:0,
      savedScrollLeft:0,
      pickerOptions:{
        disabledDate: e => {
          let chooseDate = moment(new Date(e)).format('YYYY-MM-DD') //当选择的日期
          let chooseTime = new Date(chooseDate).valueOf() //选择的时间戳
          let date = moment(new Date()).format('YYYY-MM-DD') //当前日期
          let dateTime = new Date(date).valueOf() //当前日期时间戳
          //小于等于今天的时间，可以选择。反之不能选择
          if(chooseTime<=dateTime){
            return false
          }else{
            return true
          }
        }
      }//日期
    }
  },
  computed:{
    /* 顶部通栏左侧的过滤状态文字（照 cqm2 filterText：无过滤显示 Not filtered，有则列出已过滤字段） */
    filterText(){
      let labels = {
        createTimeFrom:'Created Date',
        createTimeTo:'Created Date',
        projectType:'Project Type',
        endCustomerName:'End Customer',
        appType:'Application Type',
        stage:'Stage',
        status:'Status'
      }
      let parts = []
      for(let key in this.search){
        let value = this.search[key]
        //多选字段是数组：空数组 [] 也是真值，须按长度判断是否已过滤；其余标量字段按原逻辑
        let hasValue = Array.isArray(value) ? value.length>0 : (value || value===0)
        if(hasValue){
          let label = '【'+labels[key]+'】'
          if(parts.indexOf(label)===-1){ parts.push(label) }
        }
      }
      return parts.length>0 ? 'Filtered by'+parts.join('') : 'Not filtered'
    }
  },
  methods:{
    /* 计算并固定表格高度：以表格“实际渲染的顶部位置”为基准，视口高 − 表格顶 − 底部分页 − 底部留白。
       顶部改用实测(getBoundingClientRect)而非累加 headH+topH：吸顶头 .head-wrap 里 logo 是异步加载的图片，
       mounted 时常还没撑开高度，累加会偏小 → 表格算得过高 → 底部横向滚动条被固定分页条(.page-wrap)遮住；
       实测表格顶部能自动包含真实头部高度、top-area、各 margin 与 inline-block 基线间隙。但头部高度还会随 logo 图片与用户信息/权限菜单/语言包等异步数据到位而变(XHR 不触发 window load)，故另用 observeHeadResize() 的 ResizeObserver 兜住，见下。 */
    handleResize(){
      this.$nextTick(()=>{
        if(!this.$refs.table){ return }
        let tableEl = this.$refs.table.$el
        let pageH = this.$refs.pageBox ? this.$refs.pageBox.offsetHeight : 0
        //表格顶部到文档顶部的实际距离(rect.top 是视口相对值，+pageYOffset 转为文档相对，免受当前滚动位置影响)
        let top = tableEl.getBoundingClientRect().top + window.pageYOffset
        //16 = 表格底部与固定分页条之间保留的间距(缓冲)，确保横向滚动条完整可见不被遮
        let h = window.innerHeight - top - pageH
        this.tableHeight = h > 200 ? h : 200
        this.$refs.table.doLayout()
      })
    },
    /* 用 ResizeObserver 盯住吸顶头(.head-wrap)与顶部区(topBox)：二者高度会随 logo 图片、用户信息/权限菜单/语言包等
       异步数据到位而改变，而这些 XHR 不触发 window load，只靠 resize/load 会在头部最终长高前就定死表格高度，导致表格过高、
       底部横向滚动条被固定分页条遮住。尺寸一变即重算即可始终贴合。ResizeObserver 不可用时静默降级(仍有 resize/load 兜底)。 */
    observeHeadResize(){
      if(typeof ResizeObserver === 'undefined'){ return }
      let targets = [document.querySelector('.head-wrap'), this.$refs.topBox].filter(Boolean)
      if(!targets.length){ return }
      this.headResizeObserver = new ResizeObserver(()=>{ this.handleResize() })
      targets.forEach(el=>this.headResizeObserver.observe(el))
    },
    /* 跳转到商机详情/新增页，id 为 New 表示新增 */
    goOpportunityDetail(id='New'){
      this.$router.push({
        name:'OpportunityDetail',
        params:{ id:id }
      })
    },
    /* 切换到商机产品列表视图（opportunityProductList 路由） */
    goProductListView(){
      this.$router.push({ name:'OpportunityProductList' })
    },
    /* 双击整行进入该商机详情(编辑态，id=行 oppNo)。el-table 的 row-dblclick 首参是 row，
       不能直接写 @row-dblclick="goOpportunityDetail"(会把整个 row 当成 id 传入)，故用此包装方法取 row.oppNo */
    handleRowDblClick(row){
      this.goOpportunityDetail(row.oppNo)
    },
    handleDownload(){
      this.allLoading=true
      downFilePost(api_download_opp_list,this.search).then(res=>{
        this.allLoading=false
        this.downloadFile(res)
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 获取列表,如果是2的话，从第一页开始 */
    getList(flag=1){
      if(flag==2){
        this.paginationObj.currentPage=1
      }
      let params = {
        pageNo:this.paginationObj.currentPage,
        pageSize:this.paginationObj.pageSize,
        ...this.search
      }
      this.allLoading=true
      postAction(api_opportunity_list,params).then(res=>{
        console.log(res,'resss')
        this.allLoading=false
        this.paginationObj.total=Number(res.total)
        this.list=res.list || []
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 打开右侧过滤浮层（照 cqm2 handleFilter）；表格宽度随之变窄，需 doLayout 重排 */
    handleFilter(){
      this.showFilter=true
      this.$nextTick(()=>{ if(this.$refs.table){ this.$refs.table.doLayout() } })
    },
    /* 关闭右侧过滤浮层（照 cqm2 closeFilter） */
    closeFilter(){
      this.showFilter=false
      this.$nextTick(()=>{ if(this.$refs.table){ this.$refs.table.doLayout() } })
    },
    /* 刷新列表（照 cqm2 handleRefresh） */
    handleRefresh(){
      this.getList()
    },
    /* 详情页保存商机后通过 $root 事件通知本页刷新：本页被 keep-alive 缓存，监听常驻，
       保存完即刷新，面包屑返回时展示的已是最新数据 */
    onOpportunitySaved(){
      this.getList()
    },
    /* 绑定表格滚动监听：实时把 .el-table__body-wrapper 的横/纵滚动位置记到快照，供返回本页时还原 */
    bindTableScroll(){
      this.tableBodyEl = this.$refs.table && this.$refs.table.$el.querySelector('.el-table__body-wrapper')
      if(this.tableBodyEl){
        this.tableBodyEl.addEventListener('scroll', this.handleTableScroll)
      }
    },
    handleTableScroll(){
      if(this.tableBodyEl){
        this.savedScrollTop = this.tableBodyEl.scrollTop
        this.savedScrollLeft = this.tableBodyEl.scrollLeft
      }
    },
    /* 还原表格滚动位置：DOM 重新挂回后（$nextTick）把快照写回滚动容器，横向与纵向都恢复 */
    restoreTableScroll(){
      this.$nextTick(()=>{
        let bodyEl = this.$refs.table && this.$refs.table.$el.querySelector('.el-table__body-wrapper')
        if(bodyEl){
          bodyEl.scrollTop = this.savedScrollTop
          bodyEl.scrollLeft = this.savedScrollLeft
        }
      })
    },
    /* 重置搜索条件并且直接请求数据（照 cqm2 handleReset：重置后保持过滤浮层打开） */
    clearFilters(){
      this.search={
        createTimeFrom:'',
        createTimeTo:'',
        projectType:[], //多选，重置为空数组
        endCustomerName:'',
        appType:[], //多选，重置为空数组
        stage:[], //多选，重置为空数组
        status:[] //多选，重置为空数组
      }
      this.showFilter=true
      this.getList(2)
    }
  },
  mounted(){
    this.getList(2)
    this.getOppSelect()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    //头部 logo 图片/字体异步加载完成后重算高度：否则首次刷新时 handleResize 量到的头部偏矮，表格会过高、底部滚动条被分页条遮住
    window.addEventListener('load', this.handleResize)
    //头部高度还会随用户信息/权限菜单/语言包等异步 XHR 数据到位而变(不触发 load)，用 ResizeObserver 兜住这类变化
    this.observeHeadResize()
    //监听详情页保存商机的事件（$root 作为跨路由事件总线），保存后刷新本页列表
    this.$root.$on('opportunitySaved', this.onOpportunitySaved)
    //记录表格滚动位置，供 keep-alive 返回时还原（DOM 摘除会丢失滚动位置）
    this.bindTableScroll()
  },
  /* 与 MyOrders 一致：mounted 负责首次进入加载数据；本页 meta.keepAlive=true 被缓存后，只有从顶部菜单再次进入(query.from==='top')
     才在 activated 里重新初始化(复用 clearFilters() 清空筛选、回第一页、重拉，随后关掉过滤浮层)；
     其余入口(详情面包屑回退、产品列表切回)不动，保持缓存的筛选/页码/滚动。 */
  activated(){
    if(this.$route.query.from === 'top'){
      this.clearFilters()
      this.showFilter = false
    }else{
      //非顶部菜单进入（详情面包屑回退、产品列表切回等）：不重拉数据，还原离开前的表格滚动位置
      this.restoreTableScroll()
    }
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('load', this.handleResize)
    this.$root.$off('opportunitySaved', this.onOpportunitySaved)
    if(this.tableBodyEl){
      this.tableBodyEl.removeEventListener('scroll', this.handleTableScroll)
      this.tableBodyEl = null
    }
    if(this.headResizeObserver){
      this.headResizeObserver.disconnect()
      this.headResizeObserver = null
    }
  }
}
</script>

<style lang="less" scoped>
@import url('/public/css/public.less');
@import url('./index.less');
</style>
